import React from 'react';

const App = () => {
  return (
    <main className="App">
      {/* <div>
        <img className="imgContent" alt="ProfilePic" src={require('/Users/swethamuralidharan/fundamentals/wdi/personal-site/public/images/Pro.jpg')} height="450" width="400" />
      </div> */}
      <article className="hero">
          <p className="hero-text">
            Hello! I'm <span className="textEmphasis">Swetha.</span>  - A Web developer who loves creating interactive websites, resides in Dublin,CA.
            Well versed in MERN stack and Ruby on Rails.
            Experience working with project managers and designers in agile environments.
         </p>
      </article>
    </main>
  )
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/